import React from 'react';
import { Navbar } from '../components/layout/navbar';
import { HeroSection } from '../components/sections/heroSection';
import { IndividualSection } from '../components/sections/individualSection';
import { BusinessSection } from '../components/sections/businessSection';
import { FeaturesSection } from '../components/sections/feturesSection';
import { TestimonialsSection } from '../components/sections/testimonialsSection';
import { ContactSection } from '../components/sections/contactSection';
import { Footer } from '../components/layout/Footer';
import { FloatingAssistant } from '../components/layout/floatingAssistant';
import { PricingSection } from '../components/sections/pricingSection';
import { ExtensionInstallSection } from '../components/sections/extensionInstallSection';
import { Contact } from 'lucide-react';
import { UniversalHero } from '../components/sections/universalHero';


// Types


// Context pour le thème

const ContactPage: React.FC = () => {
    return (
        <div className="bg-white dark:bg-gray-900 transition-colors duration-300">
            <Navbar />
            <UniversalHero
                pageName="contact"
                breadcrumbs={[
                    { name: "Contact", href: "/contact" },
                ]}
                customConfig={{
                    title: "Contactez-nous",
                    subtitle: "Une équipe à votre écoute",
                    description: "Besoin d'informations, d'une assistance ou d'un partenaria? Notre vous sommes à votre disposition.",
                    primaryColor: "from-red-600 to-indigo-500",
                    secondaryColor: "bg-gradient-to-r from-purple-600 to-pink-600",
                    icon: Contact, // Assure-toi que l'icône Contact est bien importée
                    badge: "Support & Assistance",
                    backgroundPattern: "grid",
                    cta: {
                        text: "Envoyer un message",
                        link: "/contact#formulaire", // ancre vers le formulaire
                        secondary: {
                            text: "Nos bureaux",
                            link: "/contact#localisation"
                        }
                    }
                }}
            />
            <ContactSection />
            <Footer />
            <FloatingAssistant />
        </div>
    );
}
export default ContactPage;
